import React from 'react'
import styled from 'styled-components'
import { Title, Subtitle } from './Utils/CustomClasses'
import CustomImage from './Utils/CustomImage'

const Sections = styled.div`
  padding: 74px 5vw 30px 5vw;
  background-color: ${({ color }) => (color ? color : '#fff')};
  § img {
    width: 100%;
  }

  ${(props) => props.last && 'padding: 74px 5vw 130px 5vw;'}

  @media only screen and (max-width: 980px) {
    padding: 32px 0 30px 0;
    ${(props) => props.last && 'padding: 24px 3vw 90px 5vw;'}
  }

  @media only screen and (max-width: 600px) {
    padding: 24px 0 30px 0;
    ${(props) => props.last && 'padding: 24px 3vw 90px 5vw;'}
  }
`

const SafetySection = styled(Sections)`
  margin: 60px 0 0;
  padding: 34px 0 30px 0;
`

const FlexRowTrust = styled.div`
  display: flex;
  flex-direction: row;
  ${(props) => props.gap && `gap: ${props.gap}`};
  /* flex-wrap: wrap; */

  > div {
    width: 50%;
  }

  @media only screen and (max-width: 980px) {
    flex-wrap: wrap;

    > div {
      width: 100%;
    }
  }

  @media only screen and (max-width: 980px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '0')};
    ${(props) => props.reverse && 'flex-direction: column-reverse;'}
    flex-wrap: wrap;
    > div {
      width: 100%;
    }
  }

  @media only screen and (max-width: 600px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '0')};
    ${(props) => props.reverse && 'flex-direction: column-reverse;'}
    flex-wrap: wrap;
    > div {
      width: 100%;
    }
  }
`

const SectionText = styled.div`
  @media only screen and (max-width: 799px) {
    text-align: center !important;
  }

  &:first-of-type {
    margin: auto 4.5vw auto 0;

    @media only screen and (max-width: 1024px) {
      margin: auto 4vw auto 0;
    }

    @media only screen and (max-width: 980px) {
      margin: auto 0;
    }

    @media only screen and (max-width: 600px) {
      margin: auto 0;
    }
  }

  &:last-of-type {
    margin: auto 6vw auto 6vw;

    @media only screen and (max-width: 1024px) {
      margin: auto 4vw auto 4vw;
    }

    @media only screen and (max-width: 980px) {
      margin: auto 0;
    }

    @media only screen and (max-width: 600px) {
      margin: auto 0;
    }
  }
`

const CustomImageWrapper = styled.div`
  & > div {
    margin: 0 auto;
  }
`

const TrustSubtitle = styled(Subtitle)`
  color: ${({ textcolor }) => (textcolor ? textcolor : '#154549')} !importent;
  font-family: 'Open Sans', sans-serif;

  @media only screen and (max-width: 799px) {
    margin: 0 0 15px 0;
  }
`

const TrustParagraph = styled(Subtitle)`
  color: ${({ textcolor }) => (textcolor ? textcolor : '#154549')} !importent;
  font-family: 'Open Sans', sans-serif;
  font-weight: 200;

  @media only screen and (max-width: 799px) {
    margin: 0 0 50px 0;
  }
`

const WhyDoWeChargeAFee = ({ pageText, pageText2, color, textcolor }) => {
  return (
    <SafetySection color={color}>
      <FlexRowTrust gap="50px">
        <SectionText>
          <Title
            color={textcolor}
            margin="0 0 20px 0"
            size="22px"
            sizemd="22px"
            sizesm="26px"
            dangerouslySetInnerHTML={{ __html: pageText[13] }}
          />
          <TrustSubtitle
            bold
            color={textcolor}
            weight="600"
            size="20px"
            sizesm="22px"
            margin="0 0 5px 0"
            dangerouslySetInnerHTML={{ __html: pageText[14] }}
          />
          <TrustParagraph
            color={textcolor}
            weight="400"
            margin="0 0 20px 0"
            size="17px"
            sizesm="20px"
            dangerouslySetInnerHTML={{ __html: pageText[15] }}
          />
          <TrustSubtitle
            bold
            color={textcolor}
            weight="600"
            size="20px"
            sizesm="22px"
            margin="0 0 5px 0"
            dangerouslySetInnerHTML={{ __html: pageText[16] }}
          />
          <TrustParagraph
            color={textcolor}
            weight="400"
            margin="0 0 20px 0"
            size="17px"
            sizesm="20px"
            dangerouslySetInnerHTML={{ __html: pageText[17] }}
          />
          <TrustSubtitle
            bold
            color={textcolor}
            weight="600"
            size="20px"
            sizesm="22px"
            margin="0 0 5px 0"
            dangerouslySetInnerHTML={{ __html: pageText[18] }}
          />
          <TrustParagraph
            color={textcolor}
            weight="400"
            margin="0 0 20px 0"
            size="17px"
            sizesm="20px"
            dangerouslySetInnerHTML={{ __html: pageText[19] }}
          />
          <TrustParagraph
            color={textcolor}
            weight="400"
            margin="0 0 40px 0"
            size="17px"
            sizesm="20px"
            dangerouslySetInnerHTML={{ __html: pageText[20] }}
          />
        </SectionText>
        <CustomImageWrapper>
          <CustomImage
            imageBig={'/images/homepage-v2/marie-big.jpg'}
            imageSmall={'/images/homepage-v2/marie-small.jpg'}
            name={pageText2[43]}
            text={pageText2[44]}
            country={'Ireland'}
            countryFlag={'ie'}
          />
        </CustomImageWrapper>
      </FlexRowTrust>
    </SafetySection>
  )
}
export default WhyDoWeChargeAFee
